<template>
  <b-overlay
      :show="overlay"
      rounded="sm"
  >

    <div>

      <!-- Table Container Card -->
      <b-card
          no-body
          class="mb-0"
      >

        <div class="m-2">

          <!-- Table Top -->
          <b-row>

            <b-col
                cols="12"
                md="2"
                class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <b-button
                  variant="primary"
                  class=""
                  :block="$store.getters['app/currentBreakPoint'] === 'xs'"
                  @click="downloadFile"
              >
                دانلود اکسل شرکت کنندگان
              </b-button>
            </b-col>

            <b-col
                cols="12"
                md="2"
                class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <b-button
                  variant="success"
                  class=""
                  :block="$store.getters['app/currentBreakPoint'] === 'xs'"
                  @click="downloadDetailedFile"
              >
                دانلود فایل اکسل جزییات
              </b-button>
            </b-col>

            <!-- Search -->
            <b-col
                cols="12"
                md="4"
            >
              <div class="d-flex align-items-center justify-content-end">
                <b-form-input
                    v-model="searchCommand"
                    class="d-inline-block mr-1"
                    placeholder="جستجو..."
                />
              </div>
            </b-col>

            <b-col
                cols="12"
                md="2"
                class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <label>نمایش</label>
              <v-select
                  v-model="perState"
                  :options="perStateOptions"
                  :reduce="val => val.value"
                  :clearable="false"
                  class="per-page-selector d-inline-block mx-50 w-50"
              />
              <label>وضعیت</label>
            </b-col>

            <b-col
                cols="12"
                md="2"
                class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <label>نمایش</label>
              <v-select
                  v-model="perPage"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="perPageOptions"
                  :clearable="false"
                  class="per-page-selector d-inline-block mx-50"
              />
              <label>تعداد</label>
            </b-col>
          </b-row>

        </div>

        <b-table
            ref="refUserListTable"
            class="position-relative"
            :items="members"
            responsive
            :fields="myTableColumns"
            primary-key="id"
            show-empty
            bordered
            striped
            empty-text="موردی یافت نشد."
        >

          <template #cell(user.name)="data">
            <b-media vertical-align="center">
              <template #aside>
                <b-avatar
                    size="45"
                    :src="baseUrl+data.item.user.selfieFileData"
                    :variant="`success`"
                    :to="{ name: 'apps-users-edit', params: { id: data.item.user.userId } }"
                />
              </template>
              <b-link
                  :to="{ name: 'apps-users-edit', params: { id: data.item.user.userId } }"
                  class="font-weight-bold d-block text-nowrap"
              >
                {{ data.item.user.name + ' ' + data.item.user.familyName }}
              </b-link>
              <small class="text-muted">@{{ data.item.user.userId }}</small>
            </b-media>
          </template>

          <!-- Column: type -->
          <template #cell(user.type)="data">
            <b-badge
                pill
                class="text-capitalize"
                :variant="``"
            >
              {{ data.item.user.type }}
            </b-badge>
          </template>


          <!-- Column: state -->
          <template #cell(user.state)="data">
            <b-badge
                v-if="data.item.user.state === 1"
                pill
                class="text-capitalize"
                :variant="`success`"
            >
              وارد شده
            </b-badge>
            <b-badge
                v-else-if="data.item.user.state === 2"
                pill
                class="text-capitalize"
                :variant="`warning`"
            >
              فالو نکرده
            </b-badge>
            <b-badge
                v-else-if="data.item.user.state === 3"
                pill
                class="text-capitalize"
                :variant="`danger`"
            >
              آیدی اشتباه
            </b-badge>
          </template>

          <!--          &lt;!&ndash; Column: buy &ndash;&gt;-->
          <!--          <template #cell(buy)="data">-->
          <!--            <b-link :to="{ name: 'apps-buy-id', params: { id: data.item.userId } }">-->
          <!--              <feather-icon icon="ShoppingCartIcon" size="20"/>-->
          <!--            </b-link>-->
          <!--          </template>-->

          <!-- Column: chat -->
          <template #cell(ticket)="data">
            <b-link class="text-success" :to="{ name: 'apps-seminar-ticket', params: { id: data.item.orderId } }">
              <feather-icon icon="PrinterIcon" size="20"/>
            </b-link>
          </template>

          <!-- Column: chat -->
          <template #cell(chat)="data">
            <b-link :to="{ name: 'apps-chats-id', params: { id: data.item.user.userId } }">
              <feather-icon icon="MessageCircleIcon" size="20"/>
            </b-link>
          </template>

          <!--          &lt;!&ndash; Column: state &ndash;&gt;-->
          <!--          <template #cell(order.isPayed)="data">-->
          <!--            <b-badge-->
          <!--                v-if="data.item.order.isPayed === true"-->
          <!--                pill-->
          <!--                class="text-capitalize"-->
          <!--                :variant="`success`"-->
          <!--            >-->
          <!--              پرداخت شده-->
          <!--            </b-badge>-->
          <!--            <b-badge-->
          <!--                v-else-if="data.item.order.isPayed === false"-->
          <!--                pill-->
          <!--                class="text-capitalize"-->
          <!--                :variant="`danger`"-->
          <!--            >-->
          <!--              پرداخت نشده-->
          <!--            </b-badge>-->
          <!--          </template>-->

        </b-table>
        <div class="mx-2 mb-2">
          <b-row>

            <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <!--            <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>-->
            </b-col>
            <!-- Pagination -->
            <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >

              <b-pagination
                  v-model="currentPage"
                  :total-rows="totalCounts"
                  :per-page="perPage"
                  first-number
                  last-number
                  class="mb-0 mt-1 mt-sm-0"
                  prev-class="prev-item"
                  next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon style="transform: rotate(180deg)"
                                icon="ChevronLeftIcon"
                                size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                      icon="ChevronRightIcon"
                      size="18"
                  />
                </template>
              </b-pagination>

            </b-col>

          </b-row>
        </div>
      </b-card>
    </div>
  </b-overlay>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
  BBadge, BPagination, BOverlay,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Helper from "@/libs/Helper";
import {ReserveGetPurchasedSeatBySeminarIdRequest} from "@/libs/Api/Reserve";
import {SeminarGeneratesignedListBySeminarIdRequest} from "@/libs/Api/Seminar";
import axios from "axios";
import {getUserData} from "@/auth/utils";
import axiosIns from "@/libs/axios";
import { saveAs } from 'file-saver';


export default {
  name: "SeminarMembers",
  title: "لیست شرکت کنندگان سمینار - پنل ادمین نهایی شو",
  data() {
    return {
      members: null,
      baseUrl:Helper.baseUrl,
      overlay: false,
      seminarId: this.$route.params.id,
      currentPage: 1,
      totalCounts: null,
      perPage: 10,
      perPageOptions: [10, 20, 30, 40, 50],
      myTableColumns: [
        {key: 'user.name', label: 'نام کامل'},
        {key: 'user.nationalId', label: 'کد ملی'},
        {key: 'user.mobile', label: 'موبایل'},
        {key: 'user.instagramId', label: 'اینستاگرام'},
        {key: 'ticket', label: 'نمایش بلیط'},
        // { key: 'buy',label:'ثبت سفارش'},
        {key: 'user.state', label: 'وضعیت کاربر'},
        // {key: 'chat', label: 'چت'},
        // { key: 'order.isPayed' ,label :'وضعیت سفارش'},
      ],
      searchCommand: '',
      isAddNewUserSidebarActive: false,
      perState:'',
      perStateOptions:[
        {label:'همه',value:''},
        {label:'وارد شده',value:1},
        {label:'فالو نکرده',value:2},
        {label:'آیدی اشتباه',value:3}
      ],
    }
  },
  async created() {
    await this.getMembers(this.perPage, this.currentPage, this.seminarId, this.searchCommand , this.perState);
  },
  methods: {
    async getMembers(count, pageNumber, seminarId, searchCommand , state) {
      let _this = this;
      _this.overlay = true;
      let data = {
        pageNumber: pageNumber,
        count: count,
        seminarId: seminarId,
        searchCommand: searchCommand,
        state:state
      }

      let reserveGetPurchasedSeatBySeminarIdRequest = new ReserveGetPurchasedSeatBySeminarIdRequest(_this);
      reserveGetPurchasedSeatBySeminarIdRequest.setData(data);
      await reserveGetPurchasedSeatBySeminarIdRequest.fetch(function (content) {
        _this.overlay = false;
        _this.members = content.users;
        _this.totalCounts = content.usersCount;
      }, function (error) {
        _this.overlay = false;
        console.log(error);
      })
    },
    async downloadFile() {
      let _this = this;
      _this.overlay = true;
      let userToken = getUserData().token;

      await axiosIns.post(`Seminar/GenerateSignedListBySeminarId?seminarId=${_this.seminarId}`, null, {
        responseType: 'blob',
        'Authorization': userToken,
        'Token': userToken,
      }).then(resp => {
        _this.overlay = false;
         saveAs(resp.data,'seminar-members.xlsx');
      })
          .catch((error) => {
            _this.overlay = false;
            console.log(error);
          });
    },
    async downloadDetailedFile() {
      let _this = this;
      _this.overlay = true;
      let userToken = getUserData().token;

      await axiosIns.post(`Seminar/GenerateSignedDetailedListBySeminarId?seminarId=${_this.seminarId}`, null, {
        responseType: 'blob',
        'Authorization': userToken,
        'Token': userToken,
      }).then(resp => {
        _this.overlay = false;
        saveAs(resp.data,'seminar-detail.xlsx');
      })
          .catch((error) => {
            _this.overlay = false;
            console.log(error);
          });
    },
    makePrettyPrice(param) {
      return Helper.prettyPrice(param, 0)
    },
    createJalaliDate(param) {
      return new Date(param).toLocaleDateString("fa-IR",);
    },
  },
  watch: {
    perPage: function (nv, ov) {
      this.getMembers(nv, this.currentPage, this.seminarId, this.searchCommand, this.perState);
    },
    currentPage: function (nv, ov) {
      this.getMembers(this.perPage, nv, this.seminarId, this.searchCommand, this.perState);
    },
    searchCommand: function (nv, ov) {
      this.getMembers(this.perPage, this.currentPage, this.seminarId, nv , this.perState);
    },
    perState:function (nv,ov){
      this.getMembers(this.perPage, this.currentPage, this.seminarId, this.searchCommand , nv);
    }
  },
  components: {

    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BPagination,
    BOverlay,

    vSelect,
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>